import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const CleanLayout = ({ children }) => {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const menuItems = [
    { path: '/admin', name: 'Dashboard', icon: '📊' },
    { path: '/admin/links', name: 'Links', icon: '🔗' },
    { path: '/admin/domains', name: 'Domains', icon: '🌐' },
    { path: '/admin/analytics', name: 'Analytics', icon: '📈' },
    { path: '/admin/profile', name: 'Profile', icon: '👤' }
  ];

  const handleLogout = async () => {
    try {
      console.log('Logout button clicked');
      await signOut();
      console.log('SignOut completed successfully');
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      minHeight: '100vh', 
      backgroundColor: '#f8fafc',
      fontFamily: 'Inter, sans-serif'
    }}>
      {/* Sidebar */}
      <div style={{
        width: isSidebarCollapsed ? '80px' : '280px',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #e2e8f0',
        transition: 'width 0.2s ease',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Logo */}
        <div style={{ 
          padding: '24px', 
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            backgroundColor: '#3b82f6',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px'
          }}>
            🔗
          </div>
          {!isSidebarCollapsed && (
            <div>
              <div style={{ 
                fontWeight: '700', 
                fontSize: '1.125rem', 
                color: '#0f172a' 
              }}>
                ShortLink
              </div>
              <div style={{ 
                fontSize: '0.75rem', 
                color: '#64748b' 
              }}>
                URL MANAGEMENT
              </div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <div style={{ flex: 1, padding: '16px 12px' }}>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                type="button"
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  margin: '4px 0',
                  backgroundColor: isActive ? '#eff6ff' : 'transparent',
                  color: isActive ? '#3b82f6' : '#64748b',
                  border: isActive ? '1px solid #dbeafe' : '1px solid transparent',
                  borderRadius: '8px',
                  fontSize: '0.875rem',
                  fontWeight: isActive ? '600' : '500',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  textAlign: 'left'
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.target.style.backgroundColor = '#f1f5f9';
                    e.target.style.color = '#475569';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#64748b';
                  }
                }}
              >
                <span style={{ fontSize: '16px' }}>{item.icon}</span>
                {!isSidebarCollapsed && <span>{item.name}</span>}
              </button>
            );
          })}
        </div>

        {/* User Info */}
        <div style={{ 
          padding: '16px', 
          borderTop: '1px solid #e2e8f0' 
        }}>
          {!isSidebarCollapsed && user && (
            <div style={{ 
              marginBottom: '12px',
              fontSize: '0.75rem',
              color: '#64748b'
            }}>
              {user.email}
              <br />
              <span style={{ textTransform: 'uppercase', fontSize: '0.6rem' }}>
                {user.role}
              </span>
            </div>
          )}
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
              type="button"
              style={{
                padding: '8px',
                backgroundColor: 'transparent',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                color: '#64748b',
                cursor: 'pointer',
                fontSize: '14px'
              }}
              title="Toggle Sidebar"
            >
              {isSidebarCollapsed ? '→' : '←'}
            </button>
            {!isSidebarCollapsed && (
              <button
                onClick={handleLogout}
                type="button"
                style={{
                  flex: 1,
                  padding: '8px 12px',
                  backgroundColor: 'transparent',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  color: '#64748b',
                  cursor: 'pointer',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}
              >
                🚪 Logout
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ 
        flex: 1, 
        backgroundColor: '#f8fafc',
        overflow: 'auto'
      }}>
        {/* Header */}
        <div style={{
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #e2e8f0',
          padding: '16px 32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h1 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#0f172a',
              margin: '0'
            }}>
              {menuItems.find(item => item.path === location.pathname)?.name || 'Dashboard'}
            </h1>
          </div>
          <div style={{ fontSize: '0.875rem', color: '#64748b' }}>
            Welcome back, {user?.firstName || 'Demo'}
          </div>
        </div>

        {/* Page Content */}
        <div style={{ padding: '32px' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CleanLayout;